<template>
    <div class="payCode">
        <van-overlay :show="visibleDialog" z-index='100' :lock-scroll='false'>
            <div class="payCode_wrapper">
                <div class="payCode_wrapper_container">
                    <div class="payCode_wrapper_container_head"><span @click="onClose"></span>请输入钱包支付密码</div>
                    <div class="payCode_wrapper_container_content">
                        <van-password-input
                            :value="passValue"
                            :focused="showKeyboard"
                            @focus="showKeyboard = true"
                        />
                    </div>
                    <div class="payCode_wrapper_container_forget" @click="onForget">忘记密码?</div>
                </div>
            </div>
        </van-overlay>
        <van-number-keyboard
            v-model="passValue"
            :show="visibleDialog && showKeyboard"
        />
    </div>
</template>

<script>
export default {
    data () {
        return {
            passValue: '',
            showKeyboard: true
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        passValue (newVal, oldVal) {
            if (newVal.length > 6) {
                this.passValue = newVal.substring(0, 6)
            } else if (newVal.length === 6) {
                this.$emit('onPass', this.passValue)
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.show
            },
            set () {
                this.$emit('update:show')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:show')
        },
        onForget () {
            this.$router.push({ path: '/b2b/payCode/resetPayCode' })
        }
    }
}
</script>

<style lang="scss" scoped>
.payCode {
    &_wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        &_container {
            width: 590px;
            height: 348px;
            border-radius: 8px;
            background: #fff;
            position: absolute;
            top: 274px;
            &_head {
                font-size: 32px;
                color: #000;
                padding: 24px;
                text-align: center;
                position: relative;
                span {
                    position: absolute;
                    left: 24px;
                    top: 24px;
                    width: 48px;
                    height: 48px;
                    background: url('../../../../assets/img/b2b/icon_delete@2x.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
            &_content {
                padding: 48px 22px 48px 32px;
            }
            &_forget {
                text-align: center;
                font-size: 26px;
                color: #999;
            }
        }
    }
}
/deep/ .van-key {
    height: 108px;
    font-size: 50px;
}
/deep/ .van-number-keyboard {
    padding-bottom: 0;
}
/deep/ .van-key__delete-icon, /deep/ .van-key__collapse-icon {
    width: 48px;
    height: 36px;
}
/deep/ .van-password-input {
    margin: 0;
}
/deep/ .van-password-input__security {
    height: 80px;
}
/deep/ .van-password-input__security li {
    margin-right: 10px;
    position: relative;
    &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border: 2px solid #cccccc;
        -webkit-transform: scale(.5);
        transform: scale(.5);
    }
}
/deep/ .van-hairline--surround::after {
    border-width: 0;
}
</style>
